module.exports = __webpack_public_path__ + "img/big.e9beb20b.svg";